import { css, styled } from '@mui/material';
import { green, yellow, red } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { Theme } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StatusCellContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const StatusContainer = styled('span')`
  display: inline-flex;
  flex-direction: row;
`;

export const StatusItem = styled('div')<{ status: string }>`
  display: flex;
  align-items: center;
  padding-top: 0.05rem;
  padding-bottom: 0.05rem;
  padding-left: 0.5rem;
  padding-right: 0.75rem;
  border-radius: 20px;

  font-style: normal;
  font-weight: 700;
  line-height: 1rem;
  width: fit-content;
  ${({ theme }) => typographyStyles(theme)}

  & > p {
    ${({ theme }) => typographyStyles(theme)}
  }

  & > .MuiSvgIcon-root {
    margin-right: 0.15rem;
  }

  & > img {
    margin-right: 0.25rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  ${({ status }) => {
    if (status === 'new') {
      return css`
        color: #7e66e1;
        background: #f1eeff;
      `;
    }
    if (status === 'unread') {
      return css`
        color: #59c3c3;
        background: #ddfff7;
      `;
    }
    if (status === 'ready') {
      return css`
        color: #59c3c3;
        background: #ddfff7;
      `;
    }
    return css`
      color: #909090;
      background: #dddddd;
    `;
  }}
`;

// Create a base style function to reuse
export const typographyStyles = (
  theme: Theme,
  alternateSize?: boolean,
  alternateMargin?: number
) => ({
  fontSize: '1rem',
  [theme.breakpoints.down('lg')]: {
    fontSize: alternateSize ? '0.75rem' : '0.9rem',
    marginTop: alternateMargin ? `${alternateMargin}rem` : '0',
  },
});

export const CustomCheckCircleIcon = styled(CheckCircleIcon)(({ theme }) => ({
  ...typographyStyles(theme),
  color: green[700],
}));

export const CustomWatchLaterIcon = styled(WatchLaterIcon)(({ theme }) => ({
  ...typographyStyles(theme),
}));

export const CustomWarningOutlinedIcon = styled(WarningOutlinedIcon)(
  ({ theme }) => ({
    ...typographyStyles(theme),
    color: yellow[700],
  })
);

export const CustomErrorOutlinedIcon = styled(ErrorOutlinedIcon)(
  ({ theme }) => ({
    ...typographyStyles(theme),
    color: red[700],
  })
);

export const StatusText = styled(Typography)`Add commentMore actions
  font-weight: bold;
  margin-left: 3%;
  font-size: 0.9rem !important;
  text-align: center !important;
`;
